import { render, staticRenderFns } from "./tree-form.vue?vue&type=template&id=ec81d974&scoped=true&"
import script from "./tree-form.vue?vue&type=script&lang=js&"
export * from "./tree-form.vue?vue&type=script&lang=js&"
import style0 from "./tree-form.vue?vue&type=style&index=0&id=ec81d974&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec81d974",
  null
  
)

component.options.__file = "tree-form.vue"
export default component.exports